import { createPinia } from 'pinia'
import { markRaw } from 'vue'
import router from '@/router'

const pinia = createPinia()

// Add router to Pinia store context
pinia.use(({ store }) => {
  store.router = markRaw(router)
})

// Enable debug in development
if (process.env.NODE_ENV === 'development') {
  pinia.use(({ store }) => {
    store.$subscribe((mutation, state) => {
      console.log('Pinia mutation:', {
        store: mutation.storeId,
        type: mutation.type,
        payload: mutation.payload,
        state
      })
    })
  })
}

export default pinia 